export function fillTable(data: any[], tableRows: number, creationFunction: () => any): any[] {
  if ((data.length % tableRows) != 0 || data.length == 0) {
    const m = tableRows * (Math.floor(data.length / tableRows) + 1);
    for (let i = data.length; i < m; i++)
      data.push(creationFunction());
  }
  return data;
}